/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/countries';
import '../taxinator/service';
import '../billing/data';
import '../common/currency_codes';
import '../common/currency';
import '../common/time';
import './common';
import '../feeplans/pricing/headline_fee_rates';
import '../posmodes/modes/model/mode';
import '../common/client';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sub2": {
        "nested": {
          "data": {
            "nested": {
              "Entity": {
                "fields": {
                  "tokenType": {
                    "type": ".squareup.sub2.data.Entity.TokenType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "token": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "TokenType": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "INTERNAL": 1,
                      "MERCHANT": 2,
                      "PERSON": 3,
                      "MERCHANT_CONTACT": 4,
                      "REGISTRY_UID": 5
                    }
                  }
                }
              },
              "ProductOwner": {
                "fields": {
                  "productOwnerEntity": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 1,
                    "rule": "optional"
                  },
                  "ownerType": {
                    "type": ".squareup.sub2.data.ProductOwner.OwnerType",
                    "id": 2,
                    "rule": "optional"
                  },
                  "countryCode": {
                    "type": ".squareup.common.countries.Country",
                    "id": 3,
                    "rule": "optional"
                  },
                  "sellerCode": {
                    "type": ".squareup.taxinator.service.SellerCode",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "OwnerType": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "SQUARE": 1,
                      "APP_MARKETPLACE": 2,
                      "MERCHANT": 3
                    }
                  }
                }
              },
              "Duration": {
                "fields": {
                  "unit": {
                    "type": ".squareup.sub2.data.Duration.DurationUnit",
                    "id": 1,
                    "rule": "optional"
                  },
                  "count": {
                    "type": "uint32",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "DurationUnit": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "DAY": 1,
                      "MONTH": 2,
                      "YEAR": 3
                    }
                  }
                }
              },
              "Feature": {
                "values": {
                  "DO_NOT_USE": 0,
                  "RETAIL": 1,
                  "RETAIL_RATE": 23,
                  "EMPLOYEE_MANAGEMENT": 4,
                  "TEAM_MANAGEMENT_PERMISSION_SETS_BASIC": 75,
                  "TEAM_MEMBER_ONBOARDING": 103,
                  "APPOINTMENTS": 5,
                  "MARKETING": 2,
                  "MARKETING_SMS": 26,
                  "MARKETING_SMS_PREMIUM": 203,
                  "LOYALTY": 3,
                  "LOYALTY_INSIGHTS": 6,
                  "DIRECTORY": 7,
                  "CUSTOMER_DIRECTORY_SMART_DATA": 8,
                  "FEEDBACK": 9,
                  "MESSAGING": 10,
                  "CRM_ACTIVITY_LIST": 11,
                  "CRM_AUTO_PAYMENT_ASSIGNMENT": 12,
                  "CRM_INSIGHTS": 13,
                  "CRM_NOTES": 14,
                  "CRM_SMART_GROUPS": 15,
                  "CRM_SORTING": 16,
                  "CRM_LEGACY_SHOW_ALL_PAYMENTS": 17,
                  "CRM_LEGACY_CONTACT_LOOKUP": 18,
                  "CRM_CUSTOM_ATTRIBUTES": 20,
                  "ADVANCED_INVENTORY": 19,
                  "INVENTORY_BUNDLES": 86,
                  "PREMIUM_SUPPORT": 21,
                  "RESTAURANTS": 22,
                  "SPOS_DEVICE_SETTINGS": 24,
                  "RETAIL_BASIC": 25,
                  "KDS": 27,
                  "PAYROLL": 28,
                  "INVOICES_PLUS": 29,
                  "APPOINTMENTS_FREE": 30,
                  "APPOINTMENTS_PLUS": 31,
                  "APPOINTMENTS_PREMIUM": 32,
                  "APPOINTMENTS_RESOURCE_MANAGEMENT": 33,
                  "COMMISSION_TRACKING": 34,
                  "APPOINTMENTS_PROCESSING_TIME": 35,
                  "APPOINTMENTS_CLASS_BOOKING": 36,
                  "RESTAURANTS_MOBILE": 37,
                  "SHIFTS_SCHEDULING_BASIC": 38,
                  "SHIFTS_TIME_TRACKING_BASIC": 39,
                  "SHIFTS_WAGES_BASIC": 40,
                  "SHIFTS_TIPS_BASIC": 41,
                  "SHIFTS_SCHEDULING_ADVANCED": 42,
                  "SHIFTS_TIME_TRACKING_ADVANCED": 43,
                  "SHIFTS_WAGES_ADVANCED": 44,
                  "SHIFTS_TIPS_ADVANCED": 45,
                  "SHIFTS_COMMISSIONS_ADVANCED": 46,
                  "ECOM_HOSTING_FREE": 47,
                  "ECOM_HOSTING_PROFESSIONAL": 48,
                  "ECOM_HOSTING_PERFORMANCE": 49,
                  "ECOM_HOSTING_PREMIUM": 50,
                  "SHIFTS_SCHEDULING_BASIC_UNLIMITED": 51,
                  "SHIFTS_TIME_TRACKING_BASIC_UNLIMITED": 52,
                  "SHIFTS_WAGES_BASIC_UNLIMITED": 53,
                  "SHIFTS_TIPS_BASIC_UNLIMITED": 54,
                  "ECOM_PROFESSIONAL": 55,
                  "ECOM_PLUS": 56,
                  "ECOM_PREMIUM": 57,
                  "PAYPROD_PRICING_PLAN": 58,
                  "CORE": 59,
                  "WEB_ONLINE_ORDERING": 60,
                  "MOBILE_APP": 61,
                  "ECOM_FREE": 62,
                  "COMMS_ANNOUNCEMENTS": 63,
                  "COMMS_ANNOUNCEMENTS_ACK": 64,
                  "COMMS_MESSAGES": 65,
                  "COMMS_MESSAGES_TRANSLATION": 66,
                  "COMMS_TEAM_FILES": 67,
                  "COMMS_MEDIA_RETENTION_UNLIMITED": 68,
                  "COMMS_PROFANITY_FILTER": 69,
                  "COMMS_RESERVED_2": 70,
                  "COMMS_RESERVED_3": 71,
                  "COMMS_RESERVED_4": 72,
                  "COMMS_RESERVED_5": 73,
                  "COMMS_RESERVED_6": 74,
                  "MESSAGES_PLUS": 76,
                  "HR_TOOLKIT_BASIC": 77,
                  "HR_TOOLKIT_ADVANCED": 78,
                  "SPOS_AU_EXPERIMENT": 79,
                  "SPOS_PAYMENTS_PAYG": 80,
                  "SPOS_PAYMENTS_S2S": 81,
                  "SPOS_POS": 82,
                  "SPOS_PAYMENTS_PAYG_V3": 90,
                  "SPOS_POS_PAYG_V3": 91,
                  "SPOS_POS_S2S_V3": 92,
                  "SPOS_TIERED_V1_PAYG": 98,
                  "SPOS_TIERED_V1_S2S": 99,
                  "HR_MANAGER_BASIC": 83,
                  "HR_MANAGER_ADVANCED": 84,
                  "TEAM_MEMBERS": 85,
                  "FNB_KIOSK": 87,
                  "DOCUMENT_STORAGE": 88,
                  "RETAIL_PRICING_2023": 89,
                  "RESTAURANTS_FREE": 93,
                  "RESTAURANTS_PLUS": 94,
                  "RESTAURANTS_PREMIUM": 95,
                  "ADDITIONAL_RESTAURANTS_POS": 96,
                  "APPOINTMENTS_CUSTOMER_BLOCKING": 97,
                  "COMBOS": 100,
                  "NOTIFY_WHEN_READY": 101,
                  "APPOINTMENTS_SERVICE_COST": 102,
                  "APPOINTMENTS_CREDIT_PACKAGE": 104,
                  "INSTANT_ACCESS": 105,
                  "SQUARE_ONLINE": 106,
                  "ITEM_SPLITS": 107,
                  "EXPAND_FEATURE_SET": 108,
                  "CATALOG_MGMT_CREATE_ITEMS_FROM_PO": 109,
                  "CATALOG_MGMT_CREATE_BUNDLES": 110,
                  "INVENTORY_MGMT": 111,
                  "INVENTORY_MGMT_STOCK_COUNTS": 112,
                  "INVENTORY_MGMT_MANAGE_UNIT_COSTS": 113,
                  "INVENTORY_MGMT_PRINT_BARCODE_LABEL": 114,
                  "INVENTORY_MGMT_VENDOR_MGMT": 115,
                  "INVENTORY_MGMT_PO_MGMT": 116,
                  "INVENTORY_MGMT_IMPORT_PO": 117,
                  "INVENTORY_MGMT_PRINT_BARCODE_LABEL_FROM_PO": 118,
                  "INVENTORY_MGMT_TRANSFER_ORDERS": 119,
                  "INVENTORY_MGMT_STOCKABLE": 120,
                  "INVENTORY_MGMT_SELLABLE": 121,
                  "INVENTORY_STOCK_CONVERSIONS": 122,
                  "INVENTORY_HISTORY_EDITING": 123,
                  "INVENTORY_CROSS_LOC": 124,
                  "REPORTING_INVENTORY": 125,
                  "REPORTING_COGS": 126,
                  "REPORTING_PROJECTED_PROFITS": 127,
                  "REPORTING_INVENTORY_BY_CATEGORY": 128,
                  "REPORTING_AGING_INVENTORY": 129,
                  "REPORTING_VENDOR_SALES": 130,
                  "COMPLEX_TXN_EXCHANGES": 131,
                  "COMPLEX_TXN_UNLINKED_REFUNDS": 132,
                  "COMPLEX_TXN_CROSS_LOCATION_RETURNS": 133,
                  "CHECKOUT_ID_SCANNING": 134,
                  "ORDER_MGMT_CROSS_LOCATION_FULFILLMENTS": 135,
                  "APPOINTMENTS_MULTI_STAFF_RESERVATIONS": 136,
                  "APPOINTMENTS_GOOGLE_CALENDAR_SYNC": 137,
                  "APPOINTMENTS_CONFIRMATIONS": 138,
                  "APPOINTMENTS_SMS_TEMPLATING": 139,
                  "APPOINTMENTS_NO_SHOW_PROTECTION": 140,
                  "APPOINTMENTS_DAILY_RESERVATION_LIMIT": 141,
                  "APPOINTMENTS_WAITLIST": 142,
                  "APPOINTMENTS_CUSTOMER_FIELDS": 143,
                  "APPOINTMENTS_REPORTING": 144,
                  "APPOINTMENTS_API_WRITES": 145,
                  "FNB_SCAN_TO_PAY": 146,
                  "FNB_INSTANT_PAYOUTS": 147,
                  "FNB_CLOSING_PROCEDURES": 148,
                  "FNB_CLOSE_OF_DAY_REPORTS": 149,
                  "FNB_LIVE_SALES_REPORTS": 150,
                  "FNB_CATEGORY_ROLLUPS": 151,
                  "FNB_MENU_REPORTS": 152,
                  "FNB_CHECKS_WEBHOOK_PAID": 153,
                  "FNB_ITEMIZATION_FEED": 154,
                  "FNB_KITCHEN_PERFORMANCE_REPORTING": 155,
                  "FNB_INGREDIENT_COST_TRACKING": 156,
                  "FNB_THIRD_PARTY_ORDER_MANAGEMENT": 157,
                  "ORDER_MGMT_NOTIFY_WHEN_READY": 158,
                  "ITEM_COMBOS": 159,
                  "FNB_FLOOR_PLAN_CUSTOMIZATION": 160,
                  "FNB_FLOOR_PLAN_DISPLAY_TIME": 161,
                  "FNB_FLOOR_PLAN_COLOR_INDICATORS": 162,
                  "FNB_REOPEN_CLOSED_CHECKS": 163,
                  "FNB_SPLIT_CHECKS": 164,
                  "FNB_PRE_AUTH_BAR_TABS": 165,
                  "FNB_PARTY_SIZE_AUTO_GRATUITY": 166,
                  "FNB_SECTION_SALES_REPORTS": 167,
                  "FNB_SEAT_MANAGEMENT": 168,
                  "FNB_COURSE_MANAGEMENT": 169,
                  "FNB_RESERVATIONS": 170,
                  "INVOICES_MULTIPLE_INVOICE_TEMPLATES": 171,
                  "INVOICES_BATCH_INVOICE_CREATION": 172,
                  "INVOICES_ADVANCED_INVOICE_FEATURES": 173,
                  "INVOICES_ADVANCED_ESTIMATE_FEATURES": 174,
                  "INVOICES_CUSTOMIZATION_SETTINGS": 175,
                  "INVOICES_REDUCED_PROCESSING_FEES": 202,
                  "INVOICES_REDUCED_PROCESSING_FEES_NO_ACH_FEE": 218,
                  "INVOICES_PAYMENT_SCHEDULES_UPSELL": 207,
                  "INVOICES_REQUIRE_CONTRACT_SIGNATURE_UPSELL": 208,
                  "INVOICES_CUSTOM_FIELDS_UPSELL": 209,
                  "ESTIMATES_MULTIPACKAGE_UPSELL": 210,
                  "ESTIMATES_AUTOCONVERT_TO_INVOICE_UPSELL": 211,
                  "CONTRACTS_DYNAMIC_BUYER_FIELDS": 176,
                  "STAFF_UNLIMITED_CUSTOM_PERMISSION_SETS": 177,
                  "STAFF_TEAM_MEMBER_BADGES": 178,
                  "STAFF_TIMECARDS": 179,
                  "STAFF_SCHEDULING": 180,
                  "STAFF_MESSAGES": 181,
                  "STAFF_TEAM_FILES": 182,
                  "STAFF_ANNOUNCEMENTS": 183,
                  "STAFF_ADVANCED_TIP_TRACKING": 184,
                  "STAFF_COMMISSION_TRACKING": 185,
                  "STAFF_SALES_BY_TEAM_MEMBER": 186,
                  "STAFF_LABOR_VS_SALES_REPORT": 187,
                  "STAFF_ACTIVITY_LOG_BY_TEAM_MEMBER": 188,
                  "STAFF_TEAM_MEMBER_DOCUMENTS": 189,
                  "STAFF_NEW_HIRE_ONBOARDING": 190,
                  "SQUARE_ONE": 191,
                  "INVENTORY_MGMT_PENDING_RESTOCKS": 192,
                  "INVENTORY_MGMT_INVENTORY_HISTORY": 193,
                  "INVENTORY_MGMT_QUICK_RECEIVE_VIA_SCAN": 194,
                  "INVENTORY_MGMT_BULK_INVENTORY_RECEIVE": 195,
                  "REPORTING_INVENTORY_SELL_THROUGH": 196,
                  "REPORTING_STOCK_OVERVIEW": 197,
                  "FNB_RECIPES": 198,
                  "SQ1_ONLINE_FREE": 199,
                  "SQ1_ONLINE_PLUS": 200,
                  "SQ1_ONLINE_PREMIUM": 201,
                  "PHONE_SUPPORT_STANDARD": 204,
                  "PHONE_SUPPORT_PRIORITY": 205,
                  "PHONE_SUPPORT_CONCIERGE": 206,
                  "SQUARE_ONE_FREE": 212,
                  "SQUARE_ONE_PLUS": 213,
                  "SQUARE_ONE_PREMIUM": 214,
                  "FNB_SHIFT_REPORTS": 215,
                  "RESTAURANTS_POS_FREE_FEEPLAN": 216,
                  "RESTAURANTS_POS_PAID_FEEPLAN": 217,
                  "PHONE_SUPPORT_PLAN": 219,
                  "GSO_PAYMENT_PLAN": 220,
                  "LOCATION_GROUPS_MANAGEMENT": 221,
                  "RESTAURANT_INVENTORY": 222,
                  "ORDER_GUIDE": 223,
                  "GROUP_ORDERING": 224,
                  "FNB_ORDER_CONFIRMATION_SCREEN": 225,
                  "FNB_CAR_IDENTIFICATION": 226,
                  "FNB_SEND_AND_STAY": 227,
                  "ZENINREN_PRICING": 228
                }
              },
              "PlanSetting": {
                "values": {
                  "PLAN_SETTING_DO_NOT_USE": 0,
                  "ALLOWED": 1,
                  "NOT_ALLOWED": 2,
                  "CONFIGURABLE": 3
                }
              },
              "MigrationStatus": {
                "values": {
                  "SUCCESS": 1,
                  "FAILURE": 2
                }
              },
              "Plan": {
                "fields": {
                  "productOwner": {
                    "type": ".squareup.sub2.data.ProductOwner",
                    "id": 1,
                    "rule": "optional"
                  },
                  "productToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "availabilityStatus": {
                    "type": ".squareup.sub2.data.Plan.AvailabilityStatus",
                    "id": 4,
                    "rule": "optional"
                  },
                  "pricing": {
                    "type": ".squareup.sub2.data.Pricing",
                    "id": 5,
                    "rule": "optional"
                  },
                  "renewalCycle": {
                    "type": ".squareup.sub2.data.Duration",
                    "id": 6,
                    "rule": "optional"
                  },
                  "freeTrialDuration": {
                    "type": ".squareup.sub2.data.Duration",
                    "id": 7,
                    "rule": "optional"
                  },
                  "taxClass": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "feature": {
                    "type": ".squareup.sub2.data.Feature",
                    "id": 9,
                    "rule": "repeated"
                  },
                  "noObligationFreeTrialExpiredDuration": {
                    "type": ".squareup.sub2.data.Duration",
                    "id": 10,
                    "rule": "optional"
                  },
                  "token": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "requiresExpirationDate": {
                    "type": "bool",
                    "id": 12,
                    "rule": "optional"
                  },
                  "allowMissedPayments": {
                    "type": "bool",
                    "id": 13,
                    "rule": "optional"
                  },
                  "subscriberCanCancel": {
                    "type": ".squareup.sub2.data.PlanSetting",
                    "id": 14,
                    "rule": "optional"
                  },
                  "subscriberCanPause": {
                    "type": ".squareup.sub2.data.PlanSetting",
                    "id": 15,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "AvailabilityStatus": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "AVAILABLE": 1,
                      "DEPRECATED": 2,
                      "DELETED": 3
                    }
                  }
                }
              },
              "PlanVariant": {
                "fields": {
                  "planId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "id": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "availabilityStatus": {
                    "type": ".squareup.sub2.data.Plan.AvailabilityStatus",
                    "id": 3,
                    "rule": "optional"
                  },
                  "pricing": {
                    "type": ".squareup.sub2.data.Pricing",
                    "id": 4,
                    "rule": "optional"
                  },
                  "renewalCycle": {
                    "type": ".squareup.sub2.data.Duration",
                    "id": 5,
                    "rule": "optional"
                  },
                  "freeTrialDuration": {
                    "type": ".squareup.sub2.data.Duration",
                    "id": 6,
                    "rule": "optional"
                  },
                  "taxClass": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "features": {
                    "type": ".squareup.sub2.data.Feature",
                    "id": 8,
                    "rule": "repeated"
                  },
                  "noObligationFreeTrialExpiredDuration": {
                    "type": ".squareup.sub2.data.Duration",
                    "id": 9,
                    "rule": "optional"
                  },
                  "billingCycle": {
                    "type": ".squareup.billing.data.SubscriptionFeeBillCycle",
                    "id": 10,
                    "rule": "optional"
                  },
                  "countryCode": {
                    "type": ".squareup.common.countries.Country",
                    "id": 11,
                    "rule": "optional"
                  }
                }
              },
              "PlanComponent": {
                "fields": {
                  "feature": {
                    "type": ".squareup.sub2.data.Feature",
                    "id": 1,
                    "rule": "optional"
                  },
                  "plan": {
                    "type": ".squareup.sub2.data.Plan",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cancelWarning": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "maintainDescription": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "SaasMoney": {
                "fields": {
                  "currencyCode": {
                    "type": ".squareup.common.CurrencyCode",
                    "id": 1,
                    "rule": "optional"
                  },
                  "amount": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "FixedPricing": {
                "fields": {
                  "cost": {
                    "type": ".squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "UsageUnitType": {
                "values": {
                  "INVALID": 0,
                  "EMPLOYEE": 1,
                  "RETAIL_DEVICE": 2,
                  "CUSTOMER": 3,
                  "APPOINTMENTS_EMPLOYEE": 4,
                  "RESTAURANTS_LOCATION": 5,
                  "RESTAURANTS_ADDITIONAL_DEVICE": 6,
                  "RETAIL_LOCATION": 7,
                  "RETAIL_ADDITIONAL_DEVICE": 8,
                  "EMPLOYEE_MANAGEMENT_LOCATION": 9,
                  "SPOS_DEVICE_SETTINGS_DEVICE": 10,
                  "REACHABLE_CONTACTS": 11,
                  "LOYALTY_LOCATIONS": 12,
                  "LOYALTY_TRANSACTIONS": 13,
                  "LOYALTY_TRANSACTIONS_TIER": 14,
                  "PAYROLL_EMPLOYEE": 15,
                  "PAYROLL_W2_EMPLOYER": 16,
                  "MARKETING_SMS_MESSAGES": 17,
                  "LOYALTY_LOCATIONS_ON_TRANSACTION_TIER_1": 18,
                  "LOYALTY_LOCATIONS_ON_TRANSACTION_TIER_2": 19,
                  "LOYALTY_LOCATIONS_ON_TRANSACTION_TIER_3": 20,
                  "KDS_DEVICE": 21,
                  "APPOINTMENTS_LOCATIONS": 22,
                  "RESTAURANTS_MOBILE_LOCATION": 23,
                  "SHIFTS_TEAM_MEMBER": 24,
                  "ECOM_SITES": 25,
                  "ECOM_ACCOUNT": 26,
                  "MARKETING_MMS_MESSAGES": 27,
                  "COMMS_TEAM_MEMBER": 28,
                  "MESSAGES_LOCATION": 29,
                  "HR_TOOLKIT_EMPLOYEE": 30,
                  "HR_MANAGER_EMPLOYEE": 31,
                  "STAFF_TEAM_MEMBER": 32,
                  "HR_MANAGER_TEAM_MEMBER": 33,
                  "PAYROLL_MAILED_TAX_FORM": 34,
                  "STAFF_LOCATION": 35,
                  "FNB_KIOSK_DEVICE": 36,
                  "COMBOS_LOCATION": 37,
                  "FRANCHISE_LOCATION": 38,
                  "RESTAURANTS_MOBILE_DEVICE": 39,
                  "LOYALTY_PAYG_USAGE": 40,
                  "LOYALTY_PAYG_LOCATION": 41,
                  "BILLABLE_LOCATION": 42
                }
              },
              "TieredPricing": {
                "fields": {
                  "unitType": {
                    "type": ".squareup.sub2.data.UsageUnitType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "pricingTier": {
                    "type": ".squareup.sub2.data.TieredPricing.Tier",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "currentTier": {
                    "type": ".squareup.sub2.data.TieredPricing.Tier",
                    "id": 3,
                    "rule": "optional"
                  },
                  "calculation": {
                    "type": ".squareup.sub2.data.TieredPricing.Calculation",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Tier": {
                    "fields": {
                      "name": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "minUsageCount": {
                        "type": "uint32",
                        "id": 3,
                        "rule": "optional"
                      },
                      "maxUsageCount": {
                        "type": "uint32",
                        "id": 4,
                        "rule": "optional"
                      },
                      "cost": {
                        "type": ".squareup.common.Money",
                        "id": 5,
                        "rule": "optional"
                      },
                      "baseCost": {
                        "type": ".squareup.common.Money",
                        "id": 6,
                        "rule": "optional"
                      }
                    }
                  },
                  "Calculation": {
                    "values": {
                      "FIXED": 0,
                      "BULK": 1,
                      "USAGE": 2
                    }
                  }
                }
              },
              "BucketPricing": {
                "fields": {
                  "cost": {
                    "type": ".squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitType": {
                    "type": ".squareup.sub2.data.UsageUnitType",
                    "id": 2,
                    "rule": "optional"
                  },
                  "bucketSize": {
                    "type": "uint32",
                    "id": 3,
                    "rule": "optional",
                    "options": {
                      "default": 1
                    }
                  },
                  "minUnits": {
                    "type": "uint32",
                    "id": 4,
                    "rule": "optional"
                  },
                  "baseCost": {
                    "type": ".squareup.common.Money",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "UsageBucket": {
                "fields": {
                  "cost": {
                    "type": ".squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitType": {
                    "type": ".squareup.sub2.data.UsageUnitType",
                    "id": 2,
                    "rule": "optional"
                  },
                  "size": {
                    "type": "uint32",
                    "id": 3,
                    "rule": "optional",
                    "options": {
                      "default": 1
                    }
                  },
                  "minUnits": {
                    "type": "uint32",
                    "id": 4,
                    "rule": "optional"
                  },
                  "label": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "freeUnitCount": {
                    "type": "uint32",
                    "id": 6,
                    "rule": "optional"
                  },
                  "fractionalCost": {
                    "type": ".squareup.sub2.data.SaasMoney",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              },
              "MultiBucketPricing": {
                "fields": {
                  "buckets": {
                    "type": ".squareup.sub2.data.UsageBucket",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "baseCost": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "RetailPricing": {
                "fields": {
                  "retailDeviceCost": {
                    "type": ".squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "excessEmployeeCost": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "excessCustomerBucketCost": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "Pricing": {
                "fields": {
                  "label": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "startAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 7,
                    "rule": "optional"
                  },
                  "expireAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 8,
                    "rule": "optional"
                  },
                  "customPricing": {
                    "type": "bool",
                    "id": 9,
                    "rule": "optional"
                  },
                  "fixedPricing": {
                    "type": ".squareup.sub2.data.FixedPricing",
                    "id": 1
                  },
                  "bucketPricing": {
                    "type": ".squareup.sub2.data.BucketPricing",
                    "id": 2
                  },
                  "retailPricing": {
                    "type": ".squareup.sub2.data.RetailPricing",
                    "id": 3
                  },
                  "tieredPricing": {
                    "type": ".squareup.sub2.data.TieredPricing",
                    "id": 4
                  },
                  "multiBucketPricing": {
                    "type": ".squareup.sub2.data.MultiBucketPricing",
                    "id": 6
                  }
                },
                "nested": {
                  "pricing_types": {
                    "oneof": ["fixedPricing", "bucketPricing", "retailPricing", "tieredPricing", "multiBucketPricing"]
                  }
                }
              },
              "SingleUnitUsage": {
                "fields": {
                  "unitType": {
                    "type": ".squareup.sub2.data.UsageUnitType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "count": {
                    "type": "uint32",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "PlanChange": {
                "fields": {
                  "effectiveAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 1,
                    "rule": "optional"
                  },
                  "planToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "planName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "previousSubscriptionStatus": {
                    "type": ".squareup.sub2.common.SubscriptionStatus",
                    "id": 4,
                    "rule": "optional"
                  },
                  "previousPlanToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "previousPlanBillingCycle": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "Usage": {
                "fields": {
                  "unitUsages": {
                    "type": ".squareup.sub2.data.SingleUnitUsage",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "ManagedBy": {
                "values": {
                  "UNKNOWN": 0,
                  "SQUARE": 1,
                  "APPLE": 2,
                  "GOOGLE": 3
                }
              },
              "Subscription": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "subscriberEntity": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 2,
                    "rule": "optional"
                  },
                  "planToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "productOwnerEntity": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 4,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.sub2.common.SubscriptionStatus",
                    "id": 5,
                    "rule": "optional"
                  },
                  "billingStatus": {
                    "type": ".squareup.sub2.data.Subscription.BillingStatus",
                    "id": 6,
                    "rule": "optional"
                  },
                  "startAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 7,
                    "rule": "optional"
                  },
                  "endAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 8,
                    "rule": "optional"
                  },
                  "freeTrialEndDate": {
                    "type": ".squareup.common.time.YearMonthDay",
                    "id": 9,
                    "rule": "optional"
                  },
                  "renewalAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 10,
                    "rule": "optional"
                  },
                  "planName": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "freeTrialEndAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 12,
                    "rule": "optional"
                  },
                  "nextFeeAmount": {
                    "type": ".squareup.common.Money",
                    "id": 13,
                    "rule": "optional"
                  },
                  "currentUsage": {
                    "type": ".squareup.sub2.data.Usage",
                    "id": 14,
                    "rule": "optional"
                  },
                  "renewalCycle": {
                    "type": ".squareup.sub2.data.Duration",
                    "id": 15,
                    "rule": "optional"
                  },
                  "pricing": {
                    "type": ".squareup.sub2.data.Pricing",
                    "id": 16,
                    "rule": "optional"
                  },
                  "nextFeeDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 17,
                    "rule": "optional"
                  },
                  "currentCost": {
                    "type": ".squareup.common.Money",
                    "id": 18,
                    "rule": "optional"
                  },
                  "features": {
                    "type": ".squareup.sub2.data.Feature",
                    "id": 19,
                    "rule": "repeated"
                  },
                  "paused": {
                    "type": "bool",
                    "id": 20,
                    "rule": "optional"
                  },
                  "pauseAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 22,
                    "rule": "optional"
                  },
                  "resumeAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 21,
                    "rule": "optional"
                  },
                  "pendingDowngrade": {
                    "type": ".squareup.sub2.data.PlanChange",
                    "id": 23,
                    "rule": "optional"
                  },
                  "lastPlanChange": {
                    "type": ".squareup.sub2.data.PlanChange",
                    "id": 24,
                    "rule": "optional"
                  },
                  "free": {
                    "type": "bool",
                    "id": 25,
                    "rule": "optional"
                  },
                  "planGroupToken": {
                    "type": "string",
                    "id": 26,
                    "rule": "optional"
                  },
                  "planBillingCycle": {
                    "type": ".squareup.billing.data.SubscriptionFeeBillCycle",
                    "id": 28,
                    "rule": "optional"
                  },
                  "delinquentAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 29,
                    "rule": "optional"
                  },
                  "canPause": {
                    "type": "bool",
                    "id": 30,
                    "rule": "optional"
                  },
                  "bundleToken": {
                    "type": "string",
                    "id": 31,
                    "rule": "optional"
                  },
                  "managedBy": {
                    "type": ".squareup.sub2.data.ManagedBy",
                    "id": 32,
                    "rule": "optional"
                  },
                  "pendingPricing": {
                    "type": ".squareup.sub2.data.Pricing",
                    "id": 33,
                    "rule": "optional"
                  },
                  "version": {
                    "type": "int32",
                    "id": 34,
                    "rule": "optional"
                  },
                  "canCancel": {
                    "type": "bool",
                    "id": 35,
                    "rule": "optional"
                  },
                  "expireAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 36,
                    "rule": "optional"
                  },
                  "planVariantToken": {
                    "type": "string",
                    "id": 37,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "BillingStatus": {
                    "values": {
                      "NONE": 0,
                      "BILLED": 1,
                      "PAID": 2,
                      "FAILED": 3,
                      "LAPSED": 4
                    }
                  }
                }
              },
              "SubscribedFeature": {
                "fields": {
                  "feature": {
                    "type": ".squareup.sub2.data.Feature",
                    "id": 1,
                    "rule": "optional"
                  },
                  "subscriptionStatus": {
                    "type": ".squareup.sub2.common.SubscriptionStatus",
                    "id": 2,
                    "rule": "optional"
                  },
                  "subscriptionToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "enabled": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "DisplayedFeatureName": {
                "values": {
                  "DO_NOT_USE_THIS": 0,
                  "LOWER_PROCESSING": 1,
                  "UNLIMITED_TIME_TRACKING": 2,
                  "LABEL_PRINTING": 3,
                  "ADVANCED_INVENTORY_MANAGEMENT": 4,
                  "REPORTING": 5
                }
              },
              "DisplayedFeature": {
                "fields": {
                  "featureName": {
                    "type": ".squareup.sub2.data.DisplayedFeatureName",
                    "id": 1,
                    "rule": "optional"
                  },
                  "featureDescription": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "SubscriptionHistoryEvent": {
                "fields": {
                  "subscription": {
                    "type": ".squareup.sub2.data.Subscription",
                    "id": 1,
                    "rule": "optional"
                  },
                  "timestamp": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 2,
                    "rule": "optional"
                  },
                  "action": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "actor": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 4,
                    "rule": "optional"
                  },
                  "actionDetail": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "SubscriptionKey": {
                "fields": {
                  "subscriber": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 1,
                    "rule": "optional"
                  },
                  "planToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "planBillingCycle": {
                    "type": ".squareup.billing.data.SubscriptionFeeBillCycle",
                    "id": 4,
                    "rule": "optional"
                  },
                  "productOwner": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "UnavailableReason": {
                "fields": {
                  "code": {
                    "type": ".squareup.sub2.data.UnavailableReason.UnavailableReasonCode",
                    "id": 1,
                    "rule": "optional"
                  },
                  "detail": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "UnavailableReasonCode": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "RULE": 1,
                      "UNSUPPORTED": 2
                    }
                  }
                }
              },
              "LocalizedHeadlinePlanPricing": {
                "fields": {
                  "localizedAmount": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "localizedRecurrencyText": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ExternalPlan": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "description": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "free": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "available": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "unavailableReasons": {
                    "type": ".squareup.sub2.data.UnavailableReason",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "pricing": {
                    "type": ".squareup.sub2.data.Pricing",
                    "id": 7,
                    "rule": "optional"
                  },
                  "numFreeTrialDays": {
                    "type": "uint32",
                    "id": 8,
                    "rule": "optional",
                    "options": {
                      "default": 0
                    }
                  },
                  "renewalCycle": {
                    "type": ".squareup.sub2.data.Duration",
                    "id": 9,
                    "rule": "optional"
                  },
                  "estimatedCost": {
                    "type": ".squareup.common.Money",
                    "id": 10,
                    "rule": "optional"
                  },
                  "usageData": {
                    "type": ".squareup.sub2.data.Usage",
                    "id": 11,
                    "rule": "optional"
                  },
                  "billingCycle": {
                    "type": ".squareup.billing.data.SubscriptionFeeBillCycle",
                    "id": 12,
                    "rule": "optional"
                  },
                  "country": {
                    "type": ".squareup.common.countries.Country",
                    "id": 13,
                    "rule": "optional"
                  },
                  "localizedHeadlinePlanPricing": {
                    "type": ".squareup.sub2.data.LocalizedHeadlinePlanPricing",
                    "id": 14,
                    "rule": "optional"
                  },
                  "headlineFeeRates": {
                    "type": ".squareup.sub2.data.HeadlineFeeRate",
                    "id": 15,
                    "rule": "repeated"
                  },
                  "requiresExpirationDate": {
                    "type": "bool",
                    "id": 16,
                    "rule": "optional"
                  },
                  "allowMissedPayments": {
                    "type": "bool",
                    "id": 17,
                    "rule": "optional"
                  },
                  "subscriberCanCancel": {
                    "type": ".squareup.sub2.data.PlanSetting",
                    "id": 18,
                    "rule": "optional"
                  },
                  "subscriberCanPause": {
                    "type": ".squareup.sub2.data.PlanSetting",
                    "id": 19,
                    "rule": "optional"
                  }
                }
              },
              "BaseRate": {
                "fields": {
                  "variableBasisPoints": {
                    "type": "uint32",
                    "id": 1,
                    "rule": "optional"
                  },
                  "fixedCents": {
                    "type": "uint32",
                    "id": 2,
                    "rule": "optional"
                  },
                  "constraints": {
                    "type": ".squareup.sub2.data.BaseRate.FeeRateConstraint",
                    "id": 3,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "FeeRateConstraint": {
                    "fields": {
                      "type": {
                        "type": ".squareup.sub2.data.BaseRate.FeeRateConstraint.Type",
                        "id": 1,
                        "rule": "optional"
                      },
                      "amountBaseUnit": {
                        "type": "uint32",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Type": {
                        "values": {
                          "DO_NOT_USE": 0,
                          "MIN_FEE": 1,
                          "MAX_FEE": 2
                        }
                      }
                    }
                  }
                }
              },
              "HeadlineFeeRate": {
                "fields": {
                  "headlineRateName": {
                    "type": ".squareup.feeplans.pricing.HeadlineFeeRateName",
                    "id": 1,
                    "rule": "optional"
                  },
                  "localizedHeadlineRateName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "currencyCode": {
                    "type": ".squareup.common.CurrencyCode",
                    "id": 3,
                    "rule": "optional"
                  },
                  "baseRate": {
                    "type": ".squareup.sub2.data.BaseRate",
                    "id": 4,
                    "rule": "optional"
                  },
                  "localizedBaseRateDisplay": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "PlanGroup": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "plans": {
                    "type": ".squareup.sub2.data.ExternalPlan",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "compareUrl": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "tiers": {
                    "type": ".squareup.sub2.data.PlanGroupTier",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "immediateDowngrades": {
                    "type": ".squareup.sub2.data.ImmediateDowngrade",
                    "id": 5,
                    "rule": "repeated"
                  }
                }
              },
              "BundlePlanUsagePercentDiscount": {
                "fields": {
                  "unitType": {
                    "type": ".squareup.sub2.data.UsageUnitType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "percentDiscount": {
                    "type": "uint32",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "BundlePlanUsageFixedDiscount": {
                "fields": {
                  "unitType": {
                    "type": ".squareup.sub2.data.UsageUnitType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "fixedDiscount": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "PercentDiscountBundlePriceAdjustment": {
                "fields": {
                  "discountedComponents": {
                    "type": ".squareup.sub2.data.PercentDiscountBundlePriceAdjustment.DiscountedComponentType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "percent": {
                    "type": "uint32",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "DiscountedComponentType": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "BASE_FEE_ONLY": 1,
                      "USAGES_ONLY": 2,
                      "BASE_FEE_AND_USAGES": 3
                    }
                  }
                }
              },
              "PlanPercentDiscountBundlePriceAdjustment": {
                "fields": {
                  "baseFeeDiscount": {
                    "type": "uint32",
                    "id": 1,
                    "rule": "optional"
                  },
                  "usageDiscounts": {
                    "type": ".squareup.sub2.data.BundlePlanUsagePercentDiscount",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "planToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "PlanFixedDiscountBundlePriceAdjustment": {
                "fields": {
                  "baseFeeDiscount": {
                    "type": ".squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "usageDiscounts": {
                    "type": ".squareup.sub2.data.BundlePlanUsageFixedDiscount",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "planToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "BundlePriceAdjustment": {
                "fields": {
                  "label": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "percentDiscountPriceAdjustment": {
                    "type": ".squareup.sub2.data.PercentDiscountBundlePriceAdjustment",
                    "id": 1
                  },
                  "planPercentDiscountPriceAdjustment": {
                    "type": ".squareup.sub2.data.PlanPercentDiscountBundlePriceAdjustment",
                    "id": 3
                  },
                  "planFixedDiscountPriceAdjustment": {
                    "type": ".squareup.sub2.data.PlanFixedDiscountBundlePriceAdjustment",
                    "id": 4
                  }
                },
                "nested": {
                  "pricing_types": {
                    "oneof": ["percentDiscountPriceAdjustment", "planPercentDiscountPriceAdjustment", "planFixedDiscountPriceAdjustment"]
                  }
                }
              },
              "BundlePricing": {
                "fields": {
                  "priceAdjustments": {
                    "type": ".squareup.sub2.data.BundlePriceAdjustment",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "Bundle": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "subscriberEntity": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 2,
                    "rule": "optional"
                  },
                  "bundleOfferingToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "bundleOfferingVersion": {
                    "type": "uint32",
                    "id": 4,
                    "rule": "optional"
                  },
                  "bundleOfferingName": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "status": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "startAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 7,
                    "rule": "optional"
                  },
                  "endAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 8,
                    "rule": "optional"
                  },
                  "pricing": {
                    "type": ".squareup.sub2.data.BundlePricing",
                    "id": 9,
                    "rule": "repeated"
                  },
                  "expireAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 10,
                    "rule": "optional"
                  }
                }
              },
              "BundleOffering": {
                "fields": {
                  "name": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "availabilityStatus": {
                    "type": ".squareup.sub2.data.BundleOffering.AvailabilityStatus",
                    "id": 2,
                    "rule": "optional"
                  },
                  "plans": {
                    "type": ".squareup.sub2.data.ExternalPlan",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "freeTrialDuration": {
                    "type": ".squareup.sub2.data.Duration",
                    "id": 4,
                    "rule": "optional"
                  },
                  "token": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "version": {
                    "type": "uint32",
                    "id": 6,
                    "rule": "optional"
                  },
                  "pricing": {
                    "type": ".squareup.sub2.data.BundlePricing",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "offeringDuration": {
                    "type": ".squareup.sub2.data.Duration",
                    "id": 8,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "AvailabilityStatus": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "ACTIVE": 1,
                      "DISABLED": 2
                    }
                  }
                }
              },
              "FeedbackOption": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "inputType": {
                    "type": ".squareup.sub2.data.FeedbackOption.InputType",
                    "id": 2,
                    "rule": "optional"
                  },
                  "secondaryOptions": {
                    "type": ".squareup.sub2.data.FeedbackOption",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "label": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "InputType": {
                    "values": {
                      "INPUT_TYPE_DO_NOT_USE": 0,
                      "SELECT": 1,
                      "MULTISELECT": 2,
                      "TEXT": 3
                    }
                  }
                }
              },
              "FeedbackOptionList": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "feedbackOptions": {
                    "type": ".squareup.sub2.data.FeedbackOption",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "Feedback": {
                "fields": {
                  "feedbackOptionToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "text": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "SuperPOSMode": {
                "fields": {
                  "engine": {
                    "type": ".squareup.posmodes.modes.model.Mode.Engine",
                    "id": 1,
                    "rule": "optional"
                  },
                  "modeTemplateName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ActivationSource": {
                "fields": {
                  "nonPosSource": {
                    "type": "string",
                    "id": 1
                  },
                  "superPosMode": {
                    "type": ".squareup.sub2.data.SuperPOSMode",
                    "id": 2
                  }
                },
                "nested": {
                  "source": {
                    "oneof": ["nonPosSource", "superPosMode"]
                  }
                }
              },
              "SquareOneEligibility": {
                "fields": {
                  "eligible": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "eligiblePlanGroupToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "ineligibilityReason": {
                    "type": ".squareup.sub2.data.SquareOneEligibility.IneligibilityReason",
                    "id": 3,
                    "rule": "optional"
                  },
                  "flagName": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "IneligibilityReason": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "FEATURE_FLAG": 1,
                      "HAS_LEGACY_SUBSCRIPTIONS": 2,
                      "MERCHANT_CREATION_DATE": 3,
                      "MERCHANT_COUNTRY_CODE": 4,
                      "ELIGIBILITY_QUALIFIER": 5,
                      "EXPERIMENT_ROLLOUT": 6,
                      "OPTIMIZELY_INTEGRATION_ERROR": 7,
                      "UNSUPPORTED_ENTRY_POINT": 8,
                      "SUPERPOS_VERSION_TOO_LOW": 9,
                      "ELIGIBILITY_STATUS_UNDETERMINED": 10,
                      "OVERRIDE_INELIGIBLE": 11,
                      "LEGACY_CONVERSION_REQUESTED": 12,
                      "LEGACY_VERSION_TOO_LOW": 13,
                      "PNP_UNSUPPORTED_ONBOARDING": 14
                    }
                  }
                }
              },
              "GaMigrationEligibility": {
                "fields": {
                  "eligible": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "ineligibilityReason": {
                    "type": ".squareup.sub2.data.GaMigrationEligibility.GaMigrationIneligibilityReason",
                    "id": 2,
                    "rule": "optional"
                  },
                  "pendingMigrationPlanToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "GaMigrationIneligibilityReason": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "ALREADY_MIGRATED": 1,
                      "ONGOING_MIGRATION": 2,
                      "MULTIMERCHANT": 3,
                      "CONTRACTED": 4,
                      "INVOICES": 5,
                      "INELIGIBLE_COUNTRY": 6,
                      "AM_HOLDOUT": 7,
                      "PENDING_EVALUATION": 8,
                      "MANUAL_HOLDOUT": 9,
                      "SCHEDULED_MIGRATION": 10,
                      "WEEBLY_SUB": 11
                    }
                  }
                }
              },
              "ObligatedFreeTrialEligibility": {
                "fields": {
                  "experimentVariant": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "selectedPlanToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "EligibilityQualifier": {
                "fields": {
                  "onboardingEntryPoint": {
                    "type": ".squareup.sub2.data.EligibilityQualifier.OnboardingEntryPoint",
                    "id": 1,
                    "rule": "optional"
                  },
                  "superposVersion": {
                    "type": ".squareup.common.client.Version",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "OnboardingEntryPoint": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "SUPERPOS": 1,
                      "GOLDEN_PATH": 2,
                      "LEGACY_POS": 3,
                      "DASHBOARD": 4,
                      "SQUARE_ONLINE": 5,
                      "PNP_ELIGIBLE_ONBOARDING": 6,
                      "PNP_INELIGIBLE_ONBOARDING": 7
                    }
                  }
                }
              },
              "ActiveTrial": {
                "fields": {
                  "planToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "planTierToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "endAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  },
                  "obligated": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "AvailableTrial": {
                "fields": {
                  "planToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "planTierToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "days": {
                    "type": "uint32",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "ConsumedTrial": {
                "fields": {
                  "planToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "planTierToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "endAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "PlanGroupTier": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "planTokens": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "numFreeTrialDays": {
                    "type": "uint32",
                    "id": 3,
                    "rule": "optional",
                    "options": {
                      "default": 0
                    }
                  },
                  "localizedTierName": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "ImmediateDowngrade": {
                "fields": {
                  "fromPlanToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "toPlanToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "SquareOneMigrationStatus": {
                "values": {
                  "DO_NOT_USE_MIGRATION_STATUS": 0,
                  "OPTED_IN": 1,
                  "OPTED_OUT": 2,
                  "DELAYED": 3
                }
              },
              "MigrationOutcome": {
                "values": {
                  "MIGRATION_OUTCOME_UNSPECIFIED": 0,
                  "MIGRATED_VIA_OPT_IN": 1,
                  "MIGRATED_VIA_REGULATOR": 2,
                  "MIGRATED_VIA_NO_OPT_OUT": 3,
                  "NOT_MIGRATED_DUE_TO_OPT_OUT": 4,
                  "NOT_MIGRATED_DUE_TO_INELIGIBILITY": 5,
                  "NOT_MIGRATED_DUE_TO_NO_OPT_IN": 6,
                  "ALREADY_SUBSCRIBED": 7,
                  "MIGRATING": 8
                }
              },
              "PlanRuleViolationType": {
                "values": {
                  "PLAN_RULE_VIOLATION_TYPE_DO_NOT_USE": 0,
                  "USAGE_CAP_OVERAGE": 1
                }
              },
              "UsageCapOverageDetails": {
                "fields": {
                  "unitType": {
                    "type": ".squareup.sub2.data.UsageUnitType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "currentCount": {
                    "type": "uint32",
                    "id": 2,
                    "rule": "optional"
                  },
                  "maxAllowed": {
                    "type": "uint32",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "PlanRuleViolation": {
                "fields": {
                  "violationType": {
                    "type": ".squareup.sub2.data.PlanRuleViolationType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "usageCapOverage": {
                    "type": ".squareup.sub2.data.UsageCapOverageDetails",
                    "id": 2
                  }
                },
                "nested": {
                  "details": {
                    "oneof": ["usageCapOverage"]
                  }
                }
              },
              "MigrateToSquareOneTiming": {
                "values": {
                  "MIGRATE_TIMING_DO_NOT_USE": 0,
                  "IMMEDIATE": 1,
                  "OFF_HOURS": 2
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.Entity && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.Entity?.nested?.TokenType && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.ProductOwner && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.ProductOwner?.nested?.OwnerType && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.Duration && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.Duration?.nested?.DurationUnit && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.Feature && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.PlanSetting && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.MigrationStatus && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.Plan && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.Plan?.nested?.AvailabilityStatus && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.PlanVariant && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.PlanComponent && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.SaasMoney && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.FixedPricing && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.UsageUnitType && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.TieredPricing && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.TieredPricing?.nested?.Tier && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.TieredPricing?.nested?.Calculation && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.BucketPricing && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.UsageBucket && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.MultiBucketPricing && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.RetailPricing && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.Pricing && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.SingleUnitUsage && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.PlanChange && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.Usage && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.ManagedBy && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.Subscription && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.Subscription?.nested?.BillingStatus && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.SubscribedFeature && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.DisplayedFeatureName && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.DisplayedFeature && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.SubscriptionHistoryEvent && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.SubscriptionKey && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.UnavailableReason && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.UnavailableReason?.nested?.UnavailableReasonCode && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.LocalizedHeadlinePlanPricing && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.ExternalPlan && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.BaseRate && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.BaseRate?.nested?.FeeRateConstraint && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.BaseRate?.nested?.FeeRateConstraint?.nested?.Type && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.HeadlineFeeRate && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.PlanGroup && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.BundlePlanUsagePercentDiscount && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.BundlePlanUsageFixedDiscount && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.PercentDiscountBundlePriceAdjustment && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.PercentDiscountBundlePriceAdjustment?.nested?.DiscountedComponentType && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.PlanPercentDiscountBundlePriceAdjustment && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.PlanFixedDiscountBundlePriceAdjustment && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.BundlePriceAdjustment && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.BundlePricing && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.Bundle && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.BundleOffering && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.BundleOffering?.nested?.AvailabilityStatus && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.FeedbackOption && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.FeedbackOption?.nested?.InputType && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.FeedbackOptionList && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.Feedback && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.SuperPOSMode && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.ActivationSource && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.SquareOneEligibility && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.SquareOneEligibility?.nested?.IneligibilityReason && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.GaMigrationEligibility && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.GaMigrationEligibility?.nested?.GaMigrationIneligibilityReason && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.ObligatedFreeTrialEligibility && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.EligibilityQualifier && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.EligibilityQualifier?.nested?.OnboardingEntryPoint && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.ActiveTrial && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.AvailableTrial && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.ConsumedTrial && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.PlanGroupTier && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.ImmediateDowngrade && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.SquareOneMigrationStatus && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.MigrationOutcome && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.PlanRuleViolationType && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.UsageCapOverageDetails && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.PlanRuleViolation && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.MigrateToSquareOneTiming) {
  $root.addJSON(jsonData);
}

/**
 * Entity represents a physical entity in Subscriptions. For example, a merchant, a merchant's contact, etc.
 *
 * SOURCE Entity @ squareup/sub2/data.proto at 26:1
 */
export const Entity = $root.lookupType('squareup.sub2.data.Entity');
fixType(Entity, {
  tokenType: {
    required: true
  },
  token: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(Entity);
/**
 * Type of the token used to represent the entity.
 *
 * SOURCE TokenType @ squareup/sub2/data.proto at 28:3
 */
Entity.TokenType = $root.lookupEnum('squareup.sub2.data.Entity.TokenType').values;
/**
 * Deprecated
 *
 * SOURCE ProductOwner @ squareup/sub2/data.proto at 55:1
 */
export const ProductOwner = $root.lookupType('squareup.sub2.data.ProductOwner');
fixType(ProductOwner, {
  productOwnerEntity: {
    required: true
  },
  ownerType: {
    required: true
  },
  countryCode: {
    required: true
  }
});
Builder.createAndAttachToType(ProductOwner);
/**
 * Enum representing the type of the product owner entity.
 *
 * SOURCE OwnerType @ squareup/sub2/data.proto at 59:3
 */
ProductOwner.OwnerType = $root.lookupEnum('squareup.sub2.data.ProductOwner.OwnerType').values;
/**
 * Duration represents duration in days/months/years.
 *
 * SOURCE Duration @ squareup/sub2/data.proto at 108:1
 */
export const Duration = $root.lookupType('squareup.sub2.data.Duration');
fixType(Duration, {
  unit: {
    required: true
  },
  count: {
    required: true
  }
});
Builder.createAndAttachToType(Duration);
/**
 * SOURCE DurationUnit @ squareup/sub2/data.proto at 109:3
 */
Duration.DurationUnit = $root.lookupEnum('squareup.sub2.data.Duration.DurationUnit').values;
/**
 * Features represents granular features/services that a plan, when subscribed to, provides access to.
 *
 * SOURCE Feature @ squareup/sub2/data.proto at 130:1
 */
export const Feature = $root.lookupEnum('squareup.sub2.data.Feature').values;
/**
 * SOURCE PlanSetting @ squareup/sub2/data.proto at 610:1
 */
export const PlanSetting = $root.lookupEnum('squareup.sub2.data.PlanSetting').values;
/**
 * SOURCE MigrationStatus @ squareup/sub2/data.proto at 617:1
 */
export const MigrationStatus = $root.lookupEnum('squareup.sub2.data.MigrationStatus').values;
/**
 * Plan represents the entity that a subscriber can subscribe to.
 *
 * SOURCE Plan @ squareup/sub2/data.proto at 623:1
 */
export const Plan = $root.lookupType('squareup.sub2.data.Plan');
fixType(Plan, {
  availabilityStatus: {
    required: true
  },
  pricing: {
    required: true
  },
  renewalCycle: {
    required: true
  }
});
Builder.createAndAttachToType(Plan);
/**
 * AvailabilityStatus defines the various plan availability statuses.
 *
 * SOURCE AvailabilityStatus @ squareup/sub2/data.proto at 634:3
 */
Plan.AvailabilityStatus = $root.lookupEnum('squareup.sub2.data.Plan.AvailabilityStatus').values;
/**
 * Deprecated: Plan variant infrastructure is being replaced by subscriber-level
 * experiment overrides via BaseExperimentService. See SAAS-4460.
 *
 * PlanVariant represents a specific variant of a plan, differentiated by billing cycle and country.
 *
 * SOURCE PlanVariant @ squareup/sub2/data.proto at 689:1
 */
export const PlanVariant = $root.lookupType('squareup.sub2.data.PlanVariant');
fixType(PlanVariant);
Builder.createAndAttachToType(PlanVariant);
/**
 * PlanComponent represents the information about a plan that service as the canonical source for a feature
 *
 * SOURCE PlanComponent @ squareup/sub2/data.proto at 727:1
 */
export const PlanComponent = $root.lookupType('squareup.sub2.data.PlanComponent');
fixType(PlanComponent, {
  feature: {
    required: true
  },
  plan: {
    required: true
  },
  cancelWarning: {
    notEmpty: true
  },
  maintainDescription: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(PlanComponent);
/**
 * A money type with support for fractional amounts, e.g. $0.075.
 *
 * SOURCE SaasMoney @ squareup/sub2/data.proto at 742:1
 */
export const SaasMoney = $root.lookupType('squareup.sub2.data.SaasMoney');
fixType(SaasMoney, {
  currencyCode: {
    required: true
  },
  amount: {
    required: true
  }
});
Builder.createAndAttachToType(SaasMoney);
/**
 * FixedPricing represents flat fee pricing.
 *
 * SOURCE FixedPricing @ squareup/sub2/data.proto at 752:1
 */
export const FixedPricing = $root.lookupType('squareup.sub2.data.FixedPricing');
fixType(FixedPricing, {
  cost: {
    required: true
  }
});
Builder.createAndAttachToType(FixedPricing);
/**
 * The type of unit for usage/pricing. For example, employee, register device, etc.
 *
 * SOURCE UsageUnitType @ squareup/sub2/data.proto at 757:1
 */
export const UsageUnitType = $root.lookupEnum('squareup.sub2.data.UsageUnitType').values;
/**
 * TieredPricing defines various tiers that have pricing levels. Example:
 *   Tier 1: $50 for up to 25 employees
 *   Tier 2 $75 for up to 100 employees
 *
 * SOURCE TieredPricing @ squareup/sub2/data.proto at 813:1
 */
export const TieredPricing = $root.lookupType('squareup.sub2.data.TieredPricing');
fixType(TieredPricing, {
  unitType: {
    required: true
  },
  pricingTier: {
    required: true
  }
});
Builder.createAndAttachToType(TieredPricing);
/**
 * SOURCE Tier @ squareup/sub2/data.proto at 817:3
 */
TieredPricing.Tier = $root.lookupType('squareup.sub2.data.TieredPricing.Tier');
fixType(TieredPricing.Tier, {
  minUsageCount: {
    required: true
  },
  cost: {
    required: true
  }
});
Builder.createAndAttachToType(TieredPricing.Tier);
/**
 * Assuming that we have a product X and the tiers are (based on unit counts):
 * 1. 0-50
 * 2. >= 51
 *
 * SOURCE Calculation @ squareup/sub2/data.proto at 851:3
 */
TieredPricing.Calculation = $root.lookupEnum('squareup.sub2.data.TieredPricing.Calculation').values;
/**
 * BucketPricing defines pricing per number of units. Examples:
 *   $5 per 1 employee
 *   $10 per 3 register device
 *   $15 per 500 customers
 * There may also be a non-zero "base" cost, such as:
 *   $10 plus $2 per location
 *
 * SOURCE BucketPricing @ squareup/sub2/data.proto at 889:1
 */
export const BucketPricing = $root.lookupType('squareup.sub2.data.BucketPricing');
fixType(BucketPricing, {
  cost: {
    required: true
  },
  unitType: {
    required: true
  }
});
Builder.createAndAttachToType(BucketPricing);
/**
 * UsageBucket represent the bucket parameters for a single usage unit type
 *
 * SOURCE UsageBucket @ squareup/sub2/data.proto at 907:1
 */
export const UsageBucket = $root.lookupType('squareup.sub2.data.UsageBucket');
fixType(UsageBucket, {
  unitType: {
    required: true
  }
});
Builder.createAndAttachToType(UsageBucket);
/**
 * MultiBucketPricing defines pricing per number of units across multiple bucket types.
 * Examples:
 *   $60 per 1 location plus $40 per register
 *   $15 per 500 customers plus $20 per employee
 * There may also be a non-zero "base" cost, such as:
 *   $10 plus $2 per location plus $10 per employee
 *
 * SOURCE MultiBucketPricing @ squareup/sub2/data.proto at 940:1
 */
export const MultiBucketPricing = $root.lookupType('squareup.sub2.data.MultiBucketPricing');
fixType(MultiBucketPricing, {
  buckets: {
    required: true
  }
});
Builder.createAndAttachToType(MultiBucketPricing);
/**
 * The RetailPricing message is deprecated .
 *
 * SOURCE RetailPricing @ squareup/sub2/data.proto at 949:1
 */
export const RetailPricing = $root.lookupType('squareup.sub2.data.RetailPricing');
fixType(RetailPricing, {
  retailDeviceCost: {
    required: true
  },
  excessEmployeeCost: {
    required: true
  },
  excessCustomerBucketCost: {
    required: true
  }
});
Builder.createAndAttachToType(RetailPricing);
/**
 * Pricing defines a collection of different types of pricing schemes offered in Subscriptions.
 *
 * SOURCE Pricing @ squareup/sub2/data.proto at 961:1
 */
export const Pricing = $root.lookupType('squareup.sub2.data.Pricing');
fixType(Pricing);
Builder.createAndAttachToType(Pricing);
/**
 * SingleUnitUsage represents the usage per unit
 *
 * SOURCE SingleUnitUsage @ squareup/sub2/data.proto at 994:1
 */
export const SingleUnitUsage = $root.lookupType('squareup.sub2.data.SingleUnitUsage');
fixType(SingleUnitUsage, {
  unitType: {
    required: true
  },
  count: {
    required: true
  }
});
Builder.createAndAttachToType(SingleUnitUsage);
/**
 * SOURCE PlanChange @ squareup/sub2/data.proto at 1002:1
 */
export const PlanChange = $root.lookupType('squareup.sub2.data.PlanChange');
fixType(PlanChange, {
  effectiveAt: {
    required: true
  },
  planToken: {
    required: true
  },
  planName: {
    required: true
  }
});
Builder.createAndAttachToType(PlanChange);
/**
 * Usage represents the combined usage for each usage type.
 *
 * SOURCE Usage @ squareup/sub2/data.proto at 1024:1
 */
export const Usage = $root.lookupType('squareup.sub2.data.Usage');
fixType(Usage);
Builder.createAndAttachToType(Usage);
/**
 * SOURCE ManagedBy @ squareup/sub2/data.proto at 1031:1
 */
export const ManagedBy = $root.lookupEnum('squareup.sub2.data.ManagedBy').values;
/**
 * Subscription is a summary of the relation between the subscriber and the plan subscribed to.
 *
 * SOURCE Subscription @ squareup/sub2/data.proto at 1046:1
 */
export const Subscription = $root.lookupType('squareup.sub2.data.Subscription');
fixType(Subscription, {
  token: {
    notEmpty: true
  },
  subscriberEntity: {
    required: true
  },
  planToken: {
    notEmpty: true
  },
  status: {
    required: true
  },
  billingStatus: {
    required: true
  },
  planName: {
    notEmpty: true
  },
  renewalCycle: {
    required: true
  },
  pricing: {
    required: true
  }
});
Builder.createAndAttachToType(Subscription);
/**
 * BillingStatus describes the status of the subscription's billing/charges.
 *
 * SOURCE BillingStatus @ squareup/sub2/data.proto at 1063:3
 */
Subscription.BillingStatus = $root.lookupEnum('squareup.sub2.data.Subscription.BillingStatus').values;
/**
 * SOURCE SubscribedFeature @ squareup/sub2/data.proto at 1255:1
 */
export const SubscribedFeature = $root.lookupType('squareup.sub2.data.SubscribedFeature');
fixType(SubscribedFeature, {
  feature: {
    required: true
  },
  subscriptionStatus: {
    required: true
  },
  subscriptionToken: {
    notEmpty: true
  },
  enabled: {
    required: true
  }
});
Builder.createAndAttachToType(SubscribedFeature);
/**
 * SOURCE DisplayedFeatureName @ squareup/sub2/data.proto at 1269:1
 */
export const DisplayedFeatureName = $root.lookupEnum('squareup.sub2.data.DisplayedFeatureName').values;
/**
 * SOURCE DisplayedFeature @ squareup/sub2/data.proto at 1278:1
 */
export const DisplayedFeature = $root.lookupType('squareup.sub2.data.DisplayedFeature');
fixType(DisplayedFeature);
Builder.createAndAttachToType(DisplayedFeature);
/**
 * SOURCE SubscriptionHistoryEvent @ squareup/sub2/data.proto at 1358:1
 */
export const SubscriptionHistoryEvent = $root.lookupType('squareup.sub2.data.SubscriptionHistoryEvent');
fixType(SubscriptionHistoryEvent, {
  subscription: {
    notEmpty: true
  },
  timestamp: {
    required: true
  },
  actor: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(SubscriptionHistoryEvent);
/**
 * SOURCE SubscriptionKey @ squareup/sub2/data.proto at 1375:1
 */
export const SubscriptionKey = $root.lookupType('squareup.sub2.data.SubscriptionKey');
fixType(SubscriptionKey, {
  subscriber: {
    required: true
  },
  planToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(SubscriptionKey);
/**
 * SOURCE UnavailableReason @ squareup/sub2/data.proto at 1392:1
 */
export const UnavailableReason = $root.lookupType('squareup.sub2.data.UnavailableReason');
fixType(UnavailableReason);
Builder.createAndAttachToType(UnavailableReason);
/**
 * SOURCE UnavailableReasonCode @ squareup/sub2/data.proto at 1394:3
 */
UnavailableReason.UnavailableReasonCode = $root.lookupEnum('squareup.sub2.data.UnavailableReason.UnavailableReasonCode').values;
/**
 * Represents the localized headline pricing components for a plan
 *
 * SOURCE LocalizedHeadlinePlanPricing @ squareup/sub2/data.proto at 1412:1
 */
export const LocalizedHeadlinePlanPricing = $root.lookupType('squareup.sub2.data.LocalizedHeadlinePlanPricing');
fixType(LocalizedHeadlinePlanPricing);
Builder.createAndAttachToType(LocalizedHeadlinePlanPricing);
/**
 * SOURCE ExternalPlan @ squareup/sub2/data.proto at 1420:1
 */
export const ExternalPlan = $root.lookupType('squareup.sub2.data.ExternalPlan');
fixType(ExternalPlan, {
  pricing: {
    required: true
  },
  renewalCycle: {
    required: true
  }
});
Builder.createAndAttachToType(ExternalPlan);
/**
 * Represents the base rate structure for processing fees
 *
 * SOURCE BaseRate @ squareup/sub2/data.proto at 1486:1
 */
export const BaseRate = $root.lookupType('squareup.sub2.data.BaseRate');
fixType(BaseRate, {
  variableBasisPoints: {
    required: true
  },
  fixedCents: {
    required: true
  }
});
Builder.createAndAttachToType(BaseRate);
/**
 * A constraint to be applied to a FeeRate
 *
 * SOURCE FeeRateConstraint @ squareup/sub2/data.proto at 1489:3
 */
BaseRate.FeeRateConstraint = $root.lookupType('squareup.sub2.data.BaseRate.FeeRateConstraint');
fixType(BaseRate.FeeRateConstraint);
Builder.createAndAttachToType(BaseRate.FeeRateConstraint);
/**
 * SOURCE Type @ squareup/sub2/data.proto at 1490:5
 */
BaseRate.FeeRateConstraint.Type = $root.lookupEnum('squareup.sub2.data.BaseRate.FeeRateConstraint.Type').values;
/**
 * Represents a headline fee rate for a specific payment method
 *
 * SOURCE HeadlineFeeRate @ squareup/sub2/data.proto at 1520:1
 */
export const HeadlineFeeRate = $root.lookupType('squareup.sub2.data.HeadlineFeeRate');
fixType(HeadlineFeeRate, {
  headlineRateName: {
    required: true
  },
  baseRate: {
    required: true
  }
});
Builder.createAndAttachToType(HeadlineFeeRate);
/**
 * SOURCE PlanGroup @ squareup/sub2/data.proto at 1537:1
 */
export const PlanGroup = $root.lookupType('squareup.sub2.data.PlanGroup');
fixType(PlanGroup);
Builder.createAndAttachToType(PlanGroup);
/**
 * SOURCE BundlePlanUsagePercentDiscount @ squareup/sub2/data.proto at 1554:1
 */
export const BundlePlanUsagePercentDiscount = $root.lookupType('squareup.sub2.data.BundlePlanUsagePercentDiscount');
fixType(BundlePlanUsagePercentDiscount, {
  unitType: {
    required: true
  },
  percentDiscount: {
    required: true
  }
});
Builder.createAndAttachToType(BundlePlanUsagePercentDiscount);
/**
 * SOURCE BundlePlanUsageFixedDiscount @ squareup/sub2/data.proto at 1562:1
 */
export const BundlePlanUsageFixedDiscount = $root.lookupType('squareup.sub2.data.BundlePlanUsageFixedDiscount');
fixType(BundlePlanUsageFixedDiscount, {
  unitType: {
    required: true
  },
  fixedDiscount: {
    required: true
  }
});
Builder.createAndAttachToType(BundlePlanUsageFixedDiscount);
/**
 * A price adjustment for bundles that applies a percent discount to its line items.
 *
 * SOURCE PercentDiscountBundlePriceAdjustment @ squareup/sub2/data.proto at 1571:1
 */
export const PercentDiscountBundlePriceAdjustment = $root.lookupType('squareup.sub2.data.PercentDiscountBundlePriceAdjustment');
fixType(PercentDiscountBundlePriceAdjustment, {
  discountedComponents: {
    required: true
  },
  percent: {
    required: true
  }
});
Builder.createAndAttachToType(PercentDiscountBundlePriceAdjustment);
/**
 * The parts of a plan to apply the discount to.
 *
 * SOURCE DiscountedComponentType @ squareup/sub2/data.proto at 1573:3
 */
PercentDiscountBundlePriceAdjustment.DiscountedComponentType = $root.lookupEnum('squareup.sub2.data.PercentDiscountBundlePriceAdjustment.DiscountedComponentType').values;
/**
 * A price adjustment for a bundle plan that applies a percent discount to its line items.
 *
 * SOURCE PlanPercentDiscountBundlePriceAdjustment @ squareup/sub2/data.proto at 1591:1
 */
export const PlanPercentDiscountBundlePriceAdjustment = $root.lookupType('squareup.sub2.data.PlanPercentDiscountBundlePriceAdjustment');
fixType(PlanPercentDiscountBundlePriceAdjustment, {
  planToken: {
    required: true
  }
});
Builder.createAndAttachToType(PlanPercentDiscountBundlePriceAdjustment);
/**
 * A price adjustment for a bundle plan that applies a flat-dollar amount discount to its line items.
 *
 * SOURCE PlanFixedDiscountBundlePriceAdjustment @ squareup/sub2/data.proto at 1605:1
 */
export const PlanFixedDiscountBundlePriceAdjustment = $root.lookupType('squareup.sub2.data.PlanFixedDiscountBundlePriceAdjustment');
fixType(PlanFixedDiscountBundlePriceAdjustment, {
  planToken: {
    required: true
  }
});
Builder.createAndAttachToType(PlanFixedDiscountBundlePriceAdjustment);
/**
 * A collection of different pricing schemes offered for bundles.
 *
 * SOURCE BundlePriceAdjustment @ squareup/sub2/data.proto at 1619:1
 */
export const BundlePriceAdjustment = $root.lookupType('squareup.sub2.data.BundlePriceAdjustment');
fixType(BundlePriceAdjustment);
Builder.createAndAttachToType(BundlePriceAdjustment);
/**
 * BundlePricing is an object that contains all the price adjustments for a Bundle.
 *
 * SOURCE BundlePricing @ squareup/sub2/data.proto at 1633:1
 */
export const BundlePricing = $root.lookupType('squareup.sub2.data.BundlePricing');
fixType(BundlePricing, {
  priceAdjustments: {
    required: true
  }
});
Builder.createAndAttachToType(BundlePricing);
/**
 * Bundle is an object that groups multiple subscriptions together and applies discounts to them at the same time.
 *
 * SOURCE Bundle @ squareup/sub2/data.proto at 1639:1
 */
export const Bundle = $root.lookupType('squareup.sub2.data.Bundle');
fixType(Bundle, {
  token: {
    notEmpty: true
  },
  subscriberEntity: {
    required: true
  },
  bundleOfferingToken: {
    notEmpty: true
  },
  bundleOfferingVersion: {
    notEmpty: true
  },
  bundleOfferingName: {
    notEmpty: true
  },
  status: {
    notEmpty: true
  },
  startAt: {
    notEmpty: true
  },
  pricing: {
    required: true
  }
});
Builder.createAndAttachToType(Bundle);
/**
 * BundleOffering represents a set of subscription plans and their discounted rate.
 *
 * SOURCE BundleOffering @ squareup/sub2/data.proto at 1672:1
 */
export const BundleOffering = $root.lookupType('squareup.sub2.data.BundleOffering');
fixType(BundleOffering, {
  availabilityStatus: {
    required: true
  },
  plans: {
    required: true
  },
  token: {
    required: true
  },
  version: {
    required: true
  },
  pricing: {
    required: true
  }
});
Builder.createAndAttachToType(BundleOffering);
/**
 * AvailabilityStatus defines the various bundle offering availability statuses.
 *
 * SOURCE AvailabilityStatus @ squareup/sub2/data.proto at 1677:3
 */
BundleOffering.AvailabilityStatus = $root.lookupEnum('squareup.sub2.data.BundleOffering.AvailabilityStatus').values;
/**
 * SOURCE FeedbackOption @ squareup/sub2/data.proto at 1707:1
 */
export const FeedbackOption = $root.lookupType('squareup.sub2.data.FeedbackOption');
fixType(FeedbackOption, {
  token: {
    notEmpty: true
  },
  inputType: {
    required: true
  }
});
Builder.createAndAttachToType(FeedbackOption);
/**
 * SOURCE InputType @ squareup/sub2/data.proto at 1710:3
 */
FeedbackOption.InputType = $root.lookupEnum('squareup.sub2.data.FeedbackOption.InputType').values;
/**
 * SOURCE FeedbackOptionList @ squareup/sub2/data.proto at 1725:1
 */
export const FeedbackOptionList = $root.lookupType('squareup.sub2.data.FeedbackOptionList');
fixType(FeedbackOptionList, {
  token: {
    notEmpty: true
  },
  feedbackOptions: {
    required: true
  }
});
Builder.createAndAttachToType(FeedbackOptionList);
/**
 * Feedback represents an instance of feedback given during the offboarding flow. The proto is kept minimal as most of
 * the fields are only relevant for sub2 internal record keeping
 *
 * SOURCE Feedback @ squareup/sub2/data.proto at 1734:1
 */
export const Feedback = $root.lookupType('squareup.sub2.data.Feedback');
fixType(Feedback, {
  feedbackOptionToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(Feedback);
/**
 * SOURCE SuperPOSMode @ squareup/sub2/data.proto at 1744:1
 */
export const SuperPOSMode = $root.lookupType('squareup.sub2.data.SuperPOSMode');
fixType(SuperPOSMode, {
  engine: {
    required: true
  },
  modeTemplateName: {
    required: true
  }
});
Builder.createAndAttachToType(SuperPOSMode);
/**
 * ActivationSource represents the source app/platform that activated the subscription *
 *
 * SOURCE ActivationSource @ squareup/sub2/data.proto at 1751:1
 */
export const ActivationSource = $root.lookupType('squareup.sub2.data.ActivationSource');
fixType(ActivationSource);
Builder.createAndAttachToType(ActivationSource);
/**
 * SquareOneEligibility represents a seller's eligibility for Square One experiments.
 * Please note that this can return info for previous experiments when a seller already got
 * their subscription before the current running experiment.
 *
 * SOURCE SquareOneEligibility @ squareup/sub2/data.proto at 1767:1
 */
export const SquareOneEligibility = $root.lookupType('squareup.sub2.data.SquareOneEligibility');
fixType(SquareOneEligibility);
Builder.createAndAttachToType(SquareOneEligibility);
/**
 * SOURCE IneligibilityReason @ squareup/sub2/data.proto at 1768:3
 */
SquareOneEligibility.IneligibilityReason = $root.lookupEnum('squareup.sub2.data.SquareOneEligibility.IneligibilityReason').values;
/**
 * GaMigrationEligibility represents a seller's eligibility for the Square One GA Migration.
 *
 * SOURCE GaMigrationEligibility @ squareup/sub2/data.proto at 1823:1
 */
export const GaMigrationEligibility = $root.lookupType('squareup.sub2.data.GaMigrationEligibility');
fixType(GaMigrationEligibility);
Builder.createAndAttachToType(GaMigrationEligibility);
/**
 * The reason why the seller is not eligible for the Square One GA Migration
 *
 * SOURCE GaMigrationIneligibilityReason @ squareup/sub2/data.proto at 1825:3
 */
GaMigrationEligibility.GaMigrationIneligibilityReason = $root.lookupEnum('squareup.sub2.data.GaMigrationEligibility.GaMigrationIneligibilityReason').values;
/**
 * ObligatedFreeTrialEligibility represents a seller's eligibility for the Obligated Free Trial experiment.
 *
 * SOURCE ObligatedFreeTrialEligibility @ squareup/sub2/data.proto at 1871:1
 */
export const ObligatedFreeTrialEligibility = $root.lookupType('squareup.sub2.data.ObligatedFreeTrialEligibility');
fixType(ObligatedFreeTrialEligibility);
Builder.createAndAttachToType(ObligatedFreeTrialEligibility);
/**
 * SOURCE EligibilityQualifier @ squareup/sub2/data.proto at 1881:1
 */
export const EligibilityQualifier = $root.lookupType('squareup.sub2.data.EligibilityQualifier');
fixType(EligibilityQualifier, {
  onboardingEntryPoint: {
    required: true
  }
});
Builder.createAndAttachToType(EligibilityQualifier);
/**
 * SOURCE OnboardingEntryPoint @ squareup/sub2/data.proto at 1882:3
 */
EligibilityQualifier.OnboardingEntryPoint = $root.lookupEnum('squareup.sub2.data.EligibilityQualifier.OnboardingEntryPoint').values;
/**
 * A trial that has already been started.
 *
 * SOURCE ActiveTrial @ squareup/sub2/data.proto at 1918:1
 */
export const ActiveTrial = $root.lookupType('squareup.sub2.data.ActiveTrial');
fixType(ActiveTrial);
Builder.createAndAttachToType(ActiveTrial);
/**
 * A trial that could be started.
 *
 * SOURCE AvailableTrial @ squareup/sub2/data.proto at 1930:1
 */
export const AvailableTrial = $root.lookupType('squareup.sub2.data.AvailableTrial');
fixType(AvailableTrial);
Builder.createAndAttachToType(AvailableTrial);
/**
 * A trial that has ended.
 *
 * SOURCE ConsumedTrial @ squareup/sub2/data.proto at 1940:1
 */
export const ConsumedTrial = $root.lookupType('squareup.sub2.data.ConsumedTrial');
fixType(ConsumedTrial);
Builder.createAndAttachToType(ConsumedTrial);
/**
 * SOURCE PlanGroupTier @ squareup/sub2/data.proto at 1950:1
 */
export const PlanGroupTier = $root.lookupType('squareup.sub2.data.PlanGroupTier');
fixType(PlanGroupTier);
Builder.createAndAttachToType(PlanGroupTier);
/**
 * SOURCE ImmediateDowngrade @ squareup/sub2/data.proto at 1963:1
 */
export const ImmediateDowngrade = $root.lookupType('squareup.sub2.data.ImmediateDowngrade');
fixType(ImmediateDowngrade);
Builder.createAndAttachToType(ImmediateDowngrade);
/**
 * SOURCE SquareOneMigrationStatus @ squareup/sub2/data.proto at 2001:1
 */
export const SquareOneMigrationStatus = $root.lookupEnum('squareup.sub2.data.SquareOneMigrationStatus').values;
/**
 * SOURCE MigrationOutcome @ squareup/sub2/data.proto at 2011:1
 */
export const MigrationOutcome = $root.lookupEnum('squareup.sub2.data.MigrationOutcome').values;
/**
 * Types of plan rule violations.
 *
 * SOURCE PlanRuleViolationType @ squareup/sub2/data.proto at 2051:1
 */
export const PlanRuleViolationType = $root.lookupEnum('squareup.sub2.data.PlanRuleViolationType').values;
/**
 * Details when the seller is over some usage cap, such as a Free tier
 * only allowing 2 locations.
 *
 * SOURCE UsageCapOverageDetails @ squareup/sub2/data.proto at 2060:1
 */
export const UsageCapOverageDetails = $root.lookupType('squareup.sub2.data.UsageCapOverageDetails');
fixType(UsageCapOverageDetails);
Builder.createAndAttachToType(UsageCapOverageDetails);
/**
 * Represents a plan rule that the active subscription is in violation of. This
 * allows clients to block access and give sellers the reason for the restriction.
 *
 * SOURCE PlanRuleViolation @ squareup/sub2/data.proto at 2070:1
 */
export const PlanRuleViolation = $root.lookupType('squareup.sub2.data.PlanRuleViolation');
fixType(PlanRuleViolation);
Builder.createAndAttachToType(PlanRuleViolation);
/**
 * MigrateToSquareOneTiming defines when the Square One migration should happen.
 *
 * SOURCE MigrateToSquareOneTiming @ squareup/sub2/data.proto at 2078:1
 */
export const MigrateToSquareOneTiming = $root.lookupEnum('squareup.sub2.data.MigrateToSquareOneTiming').values;